var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"header__links__item  btn  btn--primary  btn--icon  btn--icon--primary",attrs:{"href":"#"},on:{"click":_vm.open}},[_c('i',{staticClass:"fas fa-search"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.__('Search')))])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d4433a6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/SearchTrigger.vue
// module id = oPdY
// module chunks = 116